import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const routes = {
  root: `/${ActivityType.TrainingModules}`,
  category: `/${ActivityType.TrainingModules}/category`,
}

export default routes
